module.exports = __webpack_public_path__ + "static/media/FireflyWorldBackground.7f83345e.svg";